<template>
	<div>
		<header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        修改绑定手机
	    </header>
	    <div class="lmy-change-phone">
	        <div class="sub-title">为了保障您的账号安全</div>
	        <div class="title">变更信息前需验证身份</div> 
	        <div class="change-phone-content bg-f">
	            <div class="icon-box"><i class="iconfont icon-shouji"></i></div>
	            <div class="content-box">
	                <p class="mobile">{{userInfo.Phone}}</p>
	                <p>通过手机验证码验证身份</p>
	                <i class="iconfont icon-more"></i>
	            </div>
	        </div>       
	    </div>
	</div>
</template>
<script>
	export default{
		name:'resetPhone',
		data(){
			return{
				userInfo:this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):''
			}
		},
		methods:{

		}
	}
	
</script>


// WEBPACK FOOTER //
// src/components/usr/resetPhone/resetPhone.vue